function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8079"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7983"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 171",
  cx: 35,
  cy: 35,
  r: 35,
  fill: "#e8f6f4"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-account-balance",
  d: "M21.489 32.082v12.507h5.234V32.082zm10.468 0v12.507h5.234V32.082zM18 53.523h33.15v-5.36H18zm24.426-21.441v12.507h5.234V32.082zM34.575 16L18 24.934v3.574h33.15v-3.574L34.575 16z",
  fill: "#a1dbd3"
}));
const SvgBankCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 70 70"
}, props), _ref);
export default SvgBankCircle;